import React from "react";

export default class BillRow extends React.PureComponent {
  render() {
    const { name, quantity, unitPrice, totalPrice, summary = false, ...rest } = this.props;
    return summary ? (
      <tr {...rest}>
        <th className="summary">{name}</th>
        <th colSpan="3" className="summary right aligned collapsing u-whiteSpaceNowrap">
          {totalPrice}
        </th>
      </tr>
    ) : (
      <tr {...rest}>
        <td>{name}</td>
        <td className="right aligned collapsing u-whiteSpaceNowrap">{unitPrice}</td>
        <td className="center aligned collapsing u-whiteSpaceNowrap">{quantity}</td>
        <td className="right aligned collapsing u-whiteSpaceNowrap">{totalPrice}</td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lib/components/BillRow.jsx